import { ArticleMetricType, FeedbackType } from '../types';
import baseUrl from '../api/baseUrl';
import joinPath from './joinPath.ts';
import {
    InteractionType,
    TrackInteractionMetadata,
    TrackInteractionRequest
} from '../api/usePostTrackInteraction.ts';
import apiPath from '../api/apiPath.ts';

async function trackInteraction(
    pagesUserId: string,
    interactionType: InteractionType,
    kbEntryId: string | null,
    metadata: TrackInteractionMetadata | null = null,
    interactionId: string | null = null
): Promise<string | undefined> {
    try {
        const request: TrackInteractionRequest = {
            interactionType,
            kbEntryId,
            metadata,
            interactionId,
            url: window.location.href
        };

        const res = await fetch(apiPath('/track_interaction'), {
            method: 'POST',
            cache: 'no-cache',
            body: JSON.stringify(request),
            headers: {
                'Content-Type': 'application/json',
                'Pages-User-Id': pagesUserId
            }
        });
        const { interactionId: newInteractionId } = await res.json();
        return newInteractionId;
    } catch {
        // Ignore interaction errors
        return undefined;
    }
}

export async function onGiveArticleFeedback(
    pagesUserId: string,
    articleId: string,
    type: ArticleMetricType
): Promise<void> {
    try {
        await fetch(
            apiPath(`article_feedback?articleId=${articleId}&type=${type}`),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Pages-User-Id': pagesUserId
                }
            }
        );

        const sessionKey = `${articleId}-interaction`;
        const event = new CustomEvent('feedbackGiven', {
            detail: { sessionKey }
        });
        window.dispatchEvent(event);
    } catch {
        // Ignore feedback errors
    }
}

export async function onGiveFeedback(
    pagesUserId: string,
    entryId: string,
    feedbackType: FeedbackType,
    score: number,
    searchText: string
): Promise<void> {
    const sessionKey = `${entryId}-interaction`;
    const previousInteractionId = sessionStorage.getItem(sessionKey);
    const latestSearchInteractionId = sessionStorage.getItem(
        'latestSearchInteractionId'
    );

    const interactionId = await trackInteraction(
        pagesUserId,
        InteractionType.FeedbackClicked,
        entryId,
        {
            feedbackType,
            score,
            searchText,
            searchInteractionId: latestSearchInteractionId
        },
        previousInteractionId
    );

    if (interactionId) {
        sessionStorage.setItem(sessionKey, interactionId);

        const event = new CustomEvent('feedbackGiven', {
            detail: { sessionKey }
        });
        window.dispatchEvent(event);
    }
}
